import { EnumMbaProduct } from './mba-amazon.constants';


/**
 * Deprecated Products
 * Note: These products are no longer available for new designs but may still exist in the catalog.
 */
export const DEPRECATED_PRODUCTS: EnumMbaProduct[] = [EnumMbaProduct.SamsungCases];
